import { render, staticRenderFns } from "./DepartmentAbout.vue?vue&type=template&id=659e6dc7&scoped=true"
import script from "./DepartmentAbout.vue?vue&type=script&lang=js"
export * from "./DepartmentAbout.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAbout.vue?vue&type=style&index=0&id=659e6dc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e6dc7",
  null
  
)

export default component.exports